import React from "react";
import PropTypes from "prop-types";
import { Add } from "@mui/icons-material";
import { Typography } from "@mui/material";

import { UIButton } from "../../../../../ui";
import { getRoleInitials, getRoleLabel, toNumber } from "../helpers";
import messages from "../../../../../../assets/locale/messages";
import { useSelector } from "react-redux";
import { clx } from "../../../../../../utils/Helpers";

const RolesNavigation = ({
  roles,
  rolesOptions,
  activeRoleIndex,
  invalidRoleIndexes,
  validationAttempt,
  hasEmptyRolesError,
  onSelectRole,
  onAddRole,
}) => {
  const lang = useSelector((state) => state.locale.lang);
  const { events } = messages[lang];
  const t = events?.creatEvent?.defineRolesAndShifts;

  return (
    <aside className="roles-navigation" aria-label={t.rolesNavigation}>
      <Typography
        className="roles-navigation__label text-label-xs"
        component="div"
      >
        {t.rolesNavigation}
      </Typography>
      <div className="roles-navigation__list">
        {roles.map((role, index) => {
          const roleLabel = getRoleLabel(role, rolesOptions, t, index);
          const capacity =
            toNumber(role.maximum_number_of_males) +
            toNumber(role.maximum_number_of_females);
          const isActive = index === activeRoleIndex;
          const isInvalid = invalidRoleIndexes.includes(index);

          return (
            <button
              className={clx("role-nav-card", {
                "role-nav-card--active": isActive,
                "role-nav-card--invalid": isInvalid,
              })}
              key={`role-${index}-${isInvalid ? validationAttempt : 0}`}
              type="button"
              onClick={() => onSelectRole(index)}
            >
              <span className="role-nav-card__top">
                <Typography
                  className="role-nav-card__name text-label-md"
                  component="span"
                >
                  {roleLabel}
                </Typography>
                <Typography
                  className="role-nav-card__badge text-body-xxs"
                  component="span"
                >
                  {getRoleInitials(index)}
                </Typography>
              </span>
              <Typography
                className="role-nav-card__meta text-body-xxs"
                component="span"
              >
                <span>{t.capacity}</span>
                <span>{capacity}</span>
              </Typography>
              <Typography
                className="role-nav-card__stats text-body-xxs"
                component="span"
              >
                <span>
                  {t.shiftCount.replace(
                    "{count}",
                    role.event_role_shifts_attributes.length,
                  )}
                </span>
                <span>{t.staffCount.replace("{count}", capacity)}</span>
              </Typography>
            </button>
          );
        })}
      </div>

      <UIButton
        className={clx("roles-navigation__add text-brand-blue-500", {
          "roles-navigation__add--invalid": hasEmptyRolesError,
        })}
        fullWidth
        startIcon={<Add />}
        variant="outlined"
        onClick={onAddRole}
        type="button"
      >
        {t.addRole}
      </UIButton>
    </aside>
  );
};

export default RolesNavigation;

RolesNavigation.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.object).isRequired,
  rolesOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeRoleIndex: PropTypes.number.isRequired,
  invalidRoleIndexes: PropTypes.arrayOf(PropTypes.number),
  validationAttempt: PropTypes.number,
  hasEmptyRolesError: PropTypes.bool,
  onSelectRole: PropTypes.func.isRequired,
  onAddRole: PropTypes.func.isRequired,
};

RolesNavigation.defaultProps = {
  invalidRoleIndexes: [],
  validationAttempt: 0,
  hasEmptyRolesError: false,
};
